export default __webpack_public_path__ + "static/media/CozyHome.060c2b09.jpg";